"use client";

import { useEffect } from "react";

import { useShareData } from "./share-data-context";

type Props = {
  shareData: ShareData;
};

/**
 * Required as it is not allowed to use hooks in react server components.
 */
export function SetShareData({ shareData }: Props) {
  const { pushShareData, popShareData } = useShareData();

  useEffect(() => {
    pushShareData(shareData);
    return function dispose() {
      popShareData();
    };
  }, [shareData, pushShareData, popShareData]);

  return null;
}
